import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DeclarativeModal } from 'seagull';
import { AgreementImportExtractionModel } from '~/models';
import { AgreementTriageModal } from './AgreementTriageModal';
const QUERY_PARAM = 'agreement-triage';
const searchWithoutTriageParam = (search)=>{
    const params = new URLSearchParams(search);
    params.delete(QUERY_PARAM);
    const remaining = params.toString();
    return remaining === '' ? '' : "?".concat(remaining);
};
const searchWithTriageParam = (search)=>{
    const params = new URLSearchParams(search);
    params.set(QUERY_PARAM, 'true');
    return "?".concat(params.toString());
};
export const useAgreementTriageModal = ()=>{
    const history = useHistory();
    return {
        open: (conversationId, extraction)=>{
            history.push({
                search: searchWithTriageParam(history.location.search),
                state: {
                    agreementTriage: {
                        conversationId,
                        extraction: extraction.toDTO()
                    }
                }
            });
        },
        close: ()=>{
            history.replace({
                search: searchWithoutTriageParam(history.location.search)
            });
        }
    };
};
export const AgreementTriageModalOpener = ()=>{
    var _location_state;
    const history = useHistory();
    const location = useLocation();
    const isRequested = new URLSearchParams(location.search).get(QUERY_PARAM) === 'true';
    const data = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.agreementTriage;
    const isOpen = isRequested && data != null;
    useEffect(()=>{
        if (isRequested && data == null) {
            history.replace({
                search: searchWithoutTriageParam(location.search)
            });
        }
    }, [
        isRequested,
        data
    ]);
    const content = (param)=>{
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(AgreementTriageModal, {
            conversationId: data.conversationId,
            extraction: AgreementImportExtractionModel.fromDTO(data.extraction),
            dismissModal: dismissModal
        });
    };
    return /*#__PURE__*/ _jsx(DeclarativeModal, {
        isOpen: isOpen,
        closeOnClickOutside: false,
        biName: "agreement_triage",
        content: content,
        onClose: ()=>{
            const currentSearch = history.location.search;
            if (!new URLSearchParams(currentSearch).has(QUERY_PARAM)) return;
            history.replace({
                search: searchWithoutTriageParam(currentSearch)
            });
        }
    });
};
